import React, { PropTypes, Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import styled from 'styled-components';
import moment from 'moment';

import { media, boolStyle } from 'style-utils';

import { isEmpty } from 'lodash';

import {
  NitroNavBar,
  NitroIconTabs,
  NitroPanel,
  NitroHeading,
  NitroText,
  NitroIcon
} from 'nitro-components';

import * as routes from '../../routes/const';

import FilterMobileComponent from '../../components/common/FilterMobileComponent';

import SectionHeader, {
  LeftSection,
  RightSection
} from '../../components/layouts/SectionHeader';

import Breakpoint from '../../utils/breakpoints';

import {
  FilterGroup,
  CountryFilter,
  CostcenterFilter,
  SingleSelect,
  DateRangeInsightsFilter
} from '../../components/filter';

// Update to default role when applying with country change
import { changeCurrentRole } from '../../auth/actions';
import {
  getCurrentRole,
  getFormatedRoles
} from '../../components/common/Profile/selector';
import { updateCurrentRole } from '../../components/common/Profile/utils';
import {
  setGlobalDynamicFilter,
  setGlobalCountryCostCenter
} from '../../action/CommonActions';

import {
  NotificationMessage,
  NotificationsSidePanel
} from '../common/GlobalNotification';

import { DEFAULT_GRAPH_DATA_API } from './const';
import ShowError from './show-error';
import InsightsSidePanel from './InsightsSidePanel';
import {
  getData,
  exportData,
  exportDocument,
  isDataEmpty,
  getActiveInsight
} from './helpers';
import ActionLinks from './components/ActionLinks';

import InsightChart from './components/InsightChart';
import InsightTable from './components/InsightTable';
import InsightsTabFilter from './components/InsightsTabFilter';

import * as actions from './actions';
import {
  getInsightsCCAndCountry,
  getInsightsDateFilter,
  getInsightsTabsFilter,
  getRestrictionFilter
} from './selector';

import DriverSafetyDetailedView from './components/driverSafety/DriverSafetyDetailedView';

const ExportAction = styled.div`
  display: inline-block;
  margin-right: 30px;
`;

const InsightsDetailGraph = styled.section`
  margin-top: 10px;
  min-height: 300px;
  ${boolStyle('hide', 'display: none;')} ${media.mobileTablet`
    margin-top: 50px;
  `};
`;

const InsightDetailTable = InsightsDetailGraph.extend`
  max-height: 500px;
  width: 100%;
  overflow: auto;
  ${boolStyle('hide', 'display: none;')};
`;

const HeaderRightContainer = styled.div`
  float: right;

  ${media.mobileTablet`float: none;`} >a {
    margin-left: 30px;
    text-decoration: none;
  }
`;

const InsightNotification = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 50px;
`;

class InsightsDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: 'Chart',
      dateFilter: {
        value: 0,
        type: 0,
        datetype: ''
      },
      selectedFilters: {},
      selectedCategory: 'empty',
      drilldownOpen: false,
      drilldownNotificationOpen: false,
      showTable: 'allCategoriesTable',
      seeAll: true,
      reportParam: {},
      fromNotification: false,
      refreshTileContent: false,
      insightDateFilters: [],
      insightsTabsFilters: []
    };
    this.deleteNotification = this.deleteNotification.bind(this);
    this.updateDetails = this.updateDetails.bind(this);
    this.isFieldValid = this.isFieldValid.bind(this);
    this.setSource = this.setSource.bind(this);
  }

  componentWillMount() {
    this.cleanStaleData();

    // this.getGraphData();
    this.props.actions.setFetchGraphData(true);
    this.props.actions.getGraphFilters({ id: this.props.routeParams.id });
    if (!isEmpty(this.props.reportParams)) {
      this.setState({
        drilldownNotificationOpen: true,
        fromNotification: true,
        reportName: this.props.reportParams.Title
      });
    }
  }

  componentWillUnMount() {
    // Clear any stale data on component unmount
    this.cleanStaleData();
  }

  componentDidUpdate(prevProps) {
    const {
      insightDateFilters,
      insightsTabsFilters,
      fetchingFilter,
      restrictions
    } = this.props;
    if (
      insightDateFilters &&
      insightDateFilters.length &&
      prevProps.insightDateFilters !== insightDateFilters &&
      !fetchingFilter
    ) {
      this.setState(
        {
          categoryGroupFilter: '',
          insightDateFilters,
          insightsTabsFilters: [],
          dateFilter: {
            type: insightDateFilters[0] ? insightDateFilters[0].type : 0,
            value: insightDateFilters[0] ? insightDateFilters[0].value : 0,
            datetype: insightDateFilters[0] ? insightDateFilters[0].datetype : 0
          }
        },
        this.getGraphData
      );
    } else if (
      insightsTabsFilters &&
      insightsTabsFilters.length &&
      prevProps.insightsTabsFilters !== insightsTabsFilters &&
      !fetchingFilter
    ) {
      const transformedInsightsTabsFilters = insightsTabsFilters.map(
        filter => ({
          ...filter,
          value: filter.params
        })
      );
      this.setState(
        {
          insightsTabsFilters: transformedInsightsTabsFilters,
          categoryGroupFilter: transformedInsightsTabsFilters[0].value
        },
        this.getGraphData
      );
    } else if (fetchingFilter !== prevProps.fetchingFilter && !fetchingFilter) {
      this.getGraphData();
    }

    if (
      this.props.reportParams !== prevProps.reportParams &&
      !isEmpty(this.props.reportParams)
    ) {
      this.setState({
        reportName: this.props.reportParams.Title,
        drilldownNotificationOpen: true,
        fromNotification: true
      });
    }

    if (this.props.routeParams.id !== prevProps.routeParams.id) {
      this.cleanStaleData();
      this.props.actions.getGraphFilters({ id: this.props.routeParams.id });
    }
  }

  cleanStaleData = () => {
    // Clear any stale data.
    this.props.actions.setInsightData({
      data: {},
      title: ''
    });

    this.setState({
      dateFilter: {
        value: 0,
        type: 0,
        datetype: ''
      },
      insightDateFilters: [],
      insightsTabsFilters: []
    });
  };

  getInsightUrl = items => {
    if (!items) {
      return;
    }

    const { id } = this.props.params;

    for (const item of items) {
      // Test current object
      if (item.id === id) {
        return item;
      }

      // Test children recursively
      const child = this.getInsightUrl(item.children);
      if (child) {
        return child;
      }
    }
  };

  getOptions = (countryObject, costcenterObject, category, restrictions) => {
    const { dateFilter, categoryGroupFilter } = this.state;
    const country = countryObject || this.props.country;
    const costcenter = costcenterObject || this.props.costcenter;

    if (!restrictions && this.props.restrictions) {
      restrictions = this.props.restrictions;
    }

    let startDate;
    let endDate;
    const datetype = {
      y: 'year',
      m: 'months',
      d: 'day'
    };

    const activeInsight = getActiveInsight(
      this.props.tiles,
      this.props.params.id
    );
    const url = activeInsight ? activeInsight.url : DEFAULT_GRAPH_DATA_API;

    const options = {
      id: this.props.routeParams.id,
      url,
      category,
      source: {
        country,
        costcenter,
        restrictions
      }
    };

    if (dateFilter.type === 'custom') {
      startDate = dateFilter.value.start;
      endDate = dateFilter.value.end;
    } else {
      // Adjust values for past dates
      if (dateFilter.value < 0) {
        const now = new Date();
        const value = Math.abs(dateFilter.value);
        startDate = moment()
          .startOf('month')
          .subtract(value, datetype[dateFilter.datetype])
          .format('D MMM YY');
        endDate = moment(now)
          .subtract(1, 'day')
          .format('D MMM YY');
      } else if (dateFilter.value > 0) {
        // Adjust values for future dates
        const date = new Date();
        const now = new Date(date.getFullYear(), date.getMonth(), 1);
        const value = Math.abs(dateFilter.value);
        endDate = moment(now)
          .add(value, datetype[dateFilter.datetype])
          .format('D MMM YY');

        startDate = moment(now).format('D MMM YY');
      }
    }

    if (startDate && endDate) {
      options.filter = {
        startDate,
        endDate
      };
    }

    if (categoryGroupFilter) {
      options.filter = Object.assign({}, options.filter, {
        categoryGroupFilter
      });
    }

    return options;
  };

  // Node.js style error first callback function
  // for getData
  getDataCallback = (error, data) => {
    // set local error state and pass
    // to child component for error message rendering
    this.setState({
      error: error || null
    });

    this.props.actions.setInsightData(data);
  };

  getGraphData = (country, costcenter, category, restrictions) => {
    const options = this.getOptions(
      country,
      costcenter,
      category,
      restrictions
    );
    getData(options, this.getDataCallback, null, this.props.actions);
  };

  sendGetTelematicsEmail = filter => {
    const data = {};
    data.Id = this.props.routeParams.id;
    data.CompanyCode = this.props.costcenter.value;
    data.CompanyName = this.props.costcenter.label;
    data.CountryCode = this.props.country.value;
    this.props.actions.sendGetTelematicsEmail(data);
  };

  switchDisplay = link => {
    this.setState({
      display: link.label
    });
  };

  onChangeTab = category => {
    this.setState(
      {
        categoryGroupFilter: category
      },
      this.getGraphData
    );
  };

  setFilters = filters => {
    const dateFilter = filters.filter(
      filterItem => filterItem.title === 'Time'
    )[0];
    this.setState(
      {
        dateFilter
      },
      this.getGraphData
    );
  };

  // Validation in case of custom date
  isFieldValid = filters => {
    if (filters.length && filters[0].type === 'custom') {
      if (!filters[0].value.start || !filters[0].value.end) {
        return false;
      }
    }
    return true;
  };

  setSource = (filters, dynFilters) => {
    const country = {
      label: filters[0].label,
      value: filters[0].value
    };
    const costcenter = {
      label: filters[1].label,
      value: filters[1].value
    };

    const restrictions = dynFilters.map(item => ({
      typeId: item.typeId,
      values: item.value.map(item => item.value)
    }));
    this.props.setGlobalCountryCostCenter({ country, costcenter });
    if (this.props.role.country !== country.value) {
      // update role when country is changed in filter
      updateCurrentRole(
        this.props.roles,
        [],
        country.value,
        'ROLEDRAWERCHANGE',
        newRole => {
          this.props.setGlobalDynamicFilter([]);
          this.props.changeCurrentRole(newRole);
          this.context.router.push(routes.INSIGHTS);
        }
      );
    }
    this.getGraphData(country, costcenter, null, restrictions);
  };

  exportCSV = () => {
    const options = this.getOptions();

    exportData(options);
  };

  exportChart = options => {
    this.refs.chart.export(options);
  };

  exportDocument = (svg, options) => {
    const chartOptions = {
      scale: 1,
      type: options.type
    };
    exportDocument(svg, chartOptions);
  };

  clickCategory = filters => {
    this.setState({
      selectedFilters: filters,
      showTable: 'allCategoriesTable',
      fromNotification: false
    });

    this.setState({
      drilldownOpen: true
    });
  };

  closeDrillDown = () => {
    this.setState(
      {
        drilldownOpen: false,
        drilldownNotificationOpen: false,
        showTable: 'allCategoriesTable'
      },
      this.props.actions.clearReportParams
    );
  };

  openDrillDown = () => {
    this.setState({
      drilldownOpen: true
    });
  };

  goBack = () => {
    const { router } = this.context;
    router.goBack();
  };

  getAllNotification = () => {
    this.setState({
      seeAll: !this.state.seeAll
    });
  };

  deleteNotification = () => {
    this.getGraphData();
  };

  updateDetails = reportParam => {
    if (this.props.reportParams !== reportParam) {
      this.props.actions.setReportParams(reportParam, true);
    } else {
      this.setState({
        reportName: this.props.reportParams.Title,
        drilldownNotificationOpen: true,
        fromNotification: true
      });
    }
  };

  getPlotOptions = (chartType, clickCategoryCb) => {
    switch (chartType) {
      case 'chartScatterPlot':
        return {
          yAxis: {
            plotBands: {
              cursor: 'pointer',
              events: {
                click(e) {
                  clickCategoryCb(this.options.filters);
                }
              }
            }
          }
        };
      case 'chartHeatMap':
        return {
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click() {
                  clickCategoryCb(this.filters);
                }
              }
            }
          }
        };
      default:
        return {
          column: {
            stacking: 'normal'
          },
          series: {
            cursor: 'pointer',
            point: {
              events: {
                click() {
                  clickCategoryCb(this.filters);
                }
              }
            }
          }
        };
    }
  };

  render() {
    const { data, country, costcenter } = this.props;
    const {
      display,
      dateFilter,
      insightDateFilters,
      insightsTabsFilters,
      categoryGroupFilter,
      error
    } = this.state;

    const chartType = data.ChartType;

    const showFilter = Boolean(insightDateFilters && insightDateFilters.length);

    const showTabs = Boolean(insightsTabsFilters && insightsTabsFilters.length);

    const displayLinks = [
      { label: 'Chart', icon: 'graph-view' },
      { label: 'Table', icon: 'table-view' }
    ];

    const filters = [
      {
        title: 'Time',
        component: DateRangeInsightsFilter,
        options: insightDateFilters,
        ...dateFilter
      }
    ];

    const categories = [
      {
        title: 'View By',
        component: SingleSelect,
        options: insightsTabsFilters,
        value: categoryGroupFilter
      }
    ];

    const source = [
      {
        title: 'Country',
        label: country.label,
        value: country.value,
        component: CountryFilter
      },
      {
        title: 'Cost Centre',
        component: CostcenterFilter,
        value: costcenter.value,
        label: costcenter.label
      }
    ];

    const NotificationMessageComponent =
      this.props.notification &&
      this.props.notification.map((item, index) => {
        if (!this.state.seeAll) {
          return (
            index <= 3 && (
              <NotificationMessage
                categoryName={item.CategoryName}
                description={item.Description}
                timeStamp={item.DaysToolText}
                displayDeleteFullWidth
                condensed
                minVersion
                key={index}
                keys={item.NotificationKeys}
                onDelete={this.deleteNotification}
                onClick={this.updateDetails}
                reportParam={item.ReportParameters}
                company={item.CompanyName}
              />
            )
          );
        }
        return (
          this.state.seeAll && (
            <NotificationMessage
              categoryName={item.CategoryName}
              description={item.Description}
              timeStamp={item.DaysToolText}
              displayDeleteFullWidth
              condensed
              minVersion
              key={index}
              keys={item.NotificationKeys}
              onDelete={this.deleteNotification}
              onClick={this.updateDetails}
              reportParam={item.ReportParameters}
              company={item.CompanyName}
            />
          )
        );
      });

    return (
      <section>
        <Breakpoint name="desktop">
          <SectionHeader margin="10px 0px 0px 0px">
            <LeftSection>
              <NitroNavBar
                label={this.props.title || ''}
                action={this.goBack}
                header
              />
            </LeftSection>
            <RightSection>
                <FilterGroup
                width="75%"
                action={this.setSource}
                title="Source"
                icon="source"
                filters={source}
                align="right"
              />
              </RightSection>
          </SectionHeader>
        </Breakpoint>
        {this.props.notification && this.props.notification.length > 0 && (
          <div>
            <NitroHeading
              header
              inline
              noMargin
              size="3"
              variant="base3"
              label="Here’s what happened while you were away"
            />
            <HeaderRightContainer>
                <Link to={routes.NOTIFICATION_SETTINGS}>
                <NitroIcon
                    name="settings"
                    size="16"
                    right={6}
                    variant="base3"
                />
                <NitroText variant="base3" size="4" bold>
                  SETTINGS
                  </NitroText>
              </Link>

                {this.props.notification.length > 4 && (
                <Link onClick={this.getAllNotification}>
                  <NitroText variant="notification" size="4" bold>
                    {this.state.seeAll
                      ? 'SEE LESS'
                      : `SEE ALL ${this.props.notification.length}`}
                  </NitroText>
                  {this.state.seeAll ? (
                    <NitroIcon
                      name="accordion-up"
                      size={8}
                      variant="notification"
                      left={6}
                    />
                  ) : (
                    <NitroIcon
                      name="accordion-down"
                      size={8}
                      variant="notification"
                      left={6}
                    />
                  )}
                </Link>
              )}
              </HeaderRightContainer>
          </div>
        )}
        <InsightNotification>
            {NotificationMessageComponent}
          </InsightNotification>

        {error ? (
          // if received data: {error} from getData callback
          // then display error message
          <NitroPanel padding="32px">
            <SectionHeader margin="0 0 20px 0">
              <ShowError />
            </SectionHeader>
          </NitroPanel>
        ) : (
          <div>
            {chartType !== 'chartDriverSafetyDetailedView' && (
              <NitroPanel padding="32px">
                <SectionHeader margin="0 0 20px 0">
                  {showFilter && (
                    <Breakpoint name="desktop">
                      <FilterGroup
                        action={this.setFilters}
                        title="Filters"
                        icon="filter"
                        filters={filters}
                        validator={this.isFieldValid}
                      />
                    </Breakpoint>
                  )}

                  {showTabs && (
                    <Breakpoint name="desktop">
                      <InsightsTabFilter
                        filters={insightsTabsFilters}
                        onChangeTab={this.onChangeTab}
                      />
                    </Breakpoint>
                  )}

                  <RightSection>
                      {!isDataEmpty(data) && (
                      <ExportAction>
                        <ActionLinks
                          exportCSV={this.exportCSV}
                          exportChart={this.exportChart}
                          exportType={this.state.display}
                        />
                      </ExportAction>
                    )}
                    <NitroIconTabs
                        active={display}
                        action={this.switchDisplay}
                        layout="horizontal"
                        data={displayLinks}
                        size="1"
                        variant="secondary"
                    />
                    </RightSection>
                </SectionHeader>

                {/** Unnecessary rendering/tranfromation of data for both table and graph.. dynamically render only one at a time */}
                {display === 'Chart' && (
                  <InsightsDetailGraph>
                    <InsightChart
                      ref="chart"
                      data={data}
                      plotOptions={this.getPlotOptions(
                        chartType,
                        this.clickCategory
                      )}
                      exportDocument={this.exportDocument}
                      graphLoading={this.props.fetchingDetailData}
                    />
                  </InsightsDetailGraph>
                )}
                {display === 'Table' && (
                  <InsightDetailTable>
                    {/* Re-added the clickCategory prop for the Insight table click - Sri */}
                    <InsightTable
                        data={data}
                        clickCategory={this.clickCategory}
                    />
                  </InsightDetailTable>
                )}
              </NitroPanel>
            )}
            {/** Special case for driver Safetydetailed view * */}
            {chartType === 'chartDriverSafetyDetailedView' && (
              <DriverSafetyDetailedView
                data={data}
                openDetails={this.clickCategory}
                sendGetTelematicsEmail={this.sendGetTelematicsEmail}
                exportCSV={this.exportCSV}
                exportChart={this.exportChart}
              />
            )}
          </div>
        )}

        <Breakpoint name="mobileTablet">
            <FilterMobileComponent
            onClickSource={this.setSource}
            onClickFilter={this.setFilters}
            onClickCategory={this.onChangeTab}
            source={source}
            filter={showFilter}
            filters={filters}
            categories={categories}
            showCategories={showTabs}
            validator={this.isFieldValid}
          />
          </Breakpoint>

        <InsightsSidePanel
              companyCode={this.props.costcenter}
              country={this.props.country}
              restrictions={this.props.restrictions}
              close={this.closeDrillDown}
              open={this.state.drilldownOpen}
              id={this.props.routeParams.id}
              category={this.state.selectedCategory}
              selectedFilters={this.state.selectedFilters}
              title={this.props.title || ''}
              showTable={this.state.showTable}
              fromNotification={this.state.fromNotification}
              reportParam={this.props.reportParams}
        />

        <NotificationsSidePanel
            close={this.closeDrillDown}
            open={this.state.drilldownNotificationOpen}
            title={this.state.reportName}
            showTable={this.state.showTable}
            reportParam={this.props.reportParams}
        />
      </section>
    );
  }
}

InsightsDetail.propTypes = {
  costcenter: PropTypes.shape({}).isRequired,
  country: PropTypes.shape({}).isRequired,
  restrictions: PropTypes.array,
  filters: PropTypes.array.isRequired,
  tiles: PropTypes.array.isRequired,
  params: PropTypes.shape({}).isRequired,
  title: PropTypes.string,
  actions: PropTypes.shape({}),
  routeParams: PropTypes.shape({}),
  data: PropTypes.shape({}),
  notification: PropTypes.array,
  location: PropTypes.shape({}),
  reportParams: PropTypes.shape({}),
  refreshFlag: PropTypes.bool,
  fetchingFilter: PropTypes.bool,
  insightDateFilters: PropTypes.array,
  insightsTabsFilters: PropTypes.array,
  setGlobalCountryCostCenter: PropTypes.func
};

InsightsDetail.contextTypes = {
  router: PropTypes.shape({}),
  location: PropTypes.shape({})
};

const mapStateToProps = state => {
  const { costcenter, country } = getInsightsCCAndCountry(state);
  const { restrictions } = getRestrictionFilter(state);

  // TODO - not sure the exact usabe of refreshFlag, add this
  // extra logic here to prevent UI exception after a failed api calls
  const refreshFlag = state.insights.refreshContentNotificationUpdate
    ? state.insights.refreshContentNotificationUpdate.update
    : true;

  return {
    filters: state.auth.config.filters,
    country,
    costcenter,
    data: state.insights.data,
    fetchingDetailData: state.insights.fetchingGraphData,
    fetchingFilter: state.insights.fetchingFilter,
    insightDateFilters: getInsightsDateFilter(state),
    insightsTabsFilters: getInsightsTabsFilter(state),
    notification: state.insights.notification,
    restrictions,
    role: getCurrentRole(state),
    roles: getFormatedRoles(state),
    reportParams: state.insights.reportParams,
    refreshFlag,
    title: state.insights.title,
    tiles: state.auth.config.tiles
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  changeCurrentRole: bindActionCreators(changeCurrentRole, dispatch),
  setGlobalCountryCostCenter: bindActionCreators(
    setGlobalCountryCostCenter,
    dispatch
  ),
  setGlobalDynamicFilter: bindActionCreators(setGlobalDynamicFilter, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(InsightsDetail);



// WEBPACK FOOTER //
// ./src/features/insights/InsightsDetail.js